module.exports = __webpack_public_path__ + "img/bih.32231661.svg";